import LOGO from "../images/Joeles.png";

export const Team__Joeles = {
  name: "Joeles",
  logoImage: LOGO,
  teamImage: null,
  teamLogoColor: "#111111",
  teamJerseyColor: "#222222",

  // Stats
  gamesWon: 1,
  gamesLost: 2,
  gamesTied: 0,
  gamesTiedWon: 0,

  ownGoalsInFavor: 37 + 27 + 24,
  goalsScoredAgainst: 25 + 28 + 28,
  defaultGoals: 0,

  isChampion: false,
  isEliminated: false,

  players: [],
};
